import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Box, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

function ResponseModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          padding: "20px",
        }}
      >
        <Button
          onClick={props.onHide}
          style={{
            position: "absolute",
            top: "10px",
            right: "5px",
            background: "none",
            border: "none",
          }}
        >
          <span style={{ fontSize: "20px", cursor: "pointer" }}>✕</span>
        </Button>

        <Box
          sx={{
            display: "flex",
            height: "100px",
            width: "100%",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <React.Fragment>
            <Box sx={{ marginRight: "15px", flexShrink: 0 }}>
              <ErrorIcon style={{ color: "#e74c3c", fontSize: "40px" }} />
            </Box>

            <Box
              sx={{
                textAlign: "left",
                flex: 1,
                wordWrap: "break-word",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                {props.message}
              </Typography>
            </Box>
          </React.Fragment>
        </Box>
      </Modal.Body>
    </Modal>
  );
}

export default ResponseModal;
